import CartRow from "../UI/Cart/CartRow"
import {withRouter} from "react-router-dom"
import {connect} from "react-redux"
import React,{useEffect, useState} from "react";
import * as actions from "../../store/actions/index"
import Spinner from "../Spinner/Spinner";
import Backdrop from "../UI/Backdrop/Backdrop"
import classes from "./OrderReview.module.css"
import {constants} from "../../firebase/firestoreNameSpaces"

const OrderReview = (props) => {
   
    const [isCartEmpty,setCartStatus] = useState(false)
    const [couponCode,setCouponCode] = useState("");
    const [isFetchedCartProducts,setIsFetchedCartProducts] = useState(false);
   const handleCouponApplyClick = (e) => {
        e.preventDefault();
        
        props.verifyCoupon(
          couponCode.toUpperCase(),
          props.order.finalPrice,
          props.order
        );
      };
    
     const handleCouponRemoveClick = (e) => {
       
        props.removeCoupon(props.order,couponCode);
      };

const getOrderSummary = ()=>{
    let orderSummary = props.orderSummary;
    let summArr = [];
    for(let sk in orderSummary){
        summArr.push(
        <div className="d-flex justify-content-between" style={{fontSize:"13px",height:"23px"}}>
            <p>{sk} : </p>
            {
                sk=="Promotion Applied"?
                <p>-Rs {orderSummary[sk]}</p>:
                <p>Rs {orderSummary[sk]}</p>
            }
        </div>
        )
    }
    return summArr
}
useEffect(()=>{
     
    if(props.user&&!isFetchedCartProducts){
        console.log("Fetching Cart Products From OrderReview")
        props.onFetchCartProducts(props.user,true);
        setIsFetchedCartProducts(true)
       }else{
        //    setTimeout(()=>{
        //         if(!props.user){
        //             setCartStatus(true)
        //         }
        //    },5000)
       }
      
},[props.user])
   
useEffect(()=>{
    props.setOrderSummary();
    // props.setCartOnProductsChange(props.order)
},[props.order])

const handlePlaceOrder = ()=>{
    let order = props.order;
    let payment_mode = order.payment_mode;
    if(payment_mode==constants.PAYMENT_CASH){
        props.payCod(order)
    }else if(payment_mode==constants.PAYMENT_ONLINE_ORDER){
        props.payOnline(order)
    }else{
        return alert("Payment Method Invalid")
    }
    
}


    if(props.cartProducts){
        if(!props.cartProducts.length){
            return <h5>Cart is Empty</h5>
        }
    }
    // if(isCartEmpty){
    //     return <h5>Cart is Empty</h5>
    // }  
    if(!props.cartProducts){
        return <Spinner/> 
    } 
    
    let {address,payment_mode} = props.order;
    return (    
        <>  
           {/* {isCartEmpty&&( <div>
                <h5>Cart is Empty</h5>
            </div>)} */} 
        
            
                <div>
                    <Backdrop show={props.placeOrderBtnLoading || props.cartLoading} clicked={props.placeOrderBtnLoading} />
                   { (props.placeOrderBtnLoading || props.cartLoading)&&<Spinner/>}
                </div>
              
               
          
            <div className="container" style={{ padding: "10px" }} >
            <h4 className="mt-2 mb-4" >Review Order</h4>
               <section>
 
                   <div className={`row`} >  
 
                          {/* <div className={`col-md-12  col-lg-9 row pt-2 mr-2  ${classes.Card} mx-auto mb-2`}
                            
                          > */}
                                <div className={`col-xs-10  col-md-4 col-lg ${classes.CardMobile} `}>
                                            <div className="row align-items-baseline">
                                                <strong className="ml-3">Shipping address</strong>

                                                
                                                <a className={`${classes.ChangeLink}`}
                                                    onClick={()=>props.setStep?props.setStep(0):void(0)}
                                                    style={{pointerEvents: props.cartLoading?"none":"visible"}}
                                                >Change</a>
                                            </div>
                                                <div className="text-left pt-2" >  
                                                    <p> 
                                                        {address.firstname + " "+ address.lastname}
                                                        <p>
                                                        {address.streetaddress}
                                                       <p>
                                                       Phone: {address.phone}
                                                       </p>
                                                        </p>
                                                       
                                                    </p>
                                                   
                                                </div>
                                        </div> 
                                        
                                <div className={`col-xs-10  col-md-4 col-lg ${classes.CardMobile} ${classes.Payment}`}>
                                            <div className="row align-items-baseline">
                                                <strong className="ml-3">Payment method</strong>
                                                <a className={`${classes.ChangeLink}`}
                                                    onClick={()=>props.setStep?props.setStep(1):void(0)}
                                                    style={{pointerEvents: props.cartLoading?"none":"visible"}}
                                                >Change</a>
                                            </div>
                                                <div className="text-left pt-2" >
                                                    <p>
                                                        {
                                                            payment_mode==constants.PAYMENT_CASH?"Pay on delivery (cash/card)":payment_mode==constants.PAYMENT_ONLINE_ORDER?"Cashless (Card/Net Banking/Upi)":payment_mode
                                                        }
                                                    </p>
                                                </div> 
                                            </div>
                                <div className={`col-xs-10  col-md-4 col-lg ${classes.CardMobile} ${classes.Coupon}`}>
                                                <strong className="ml-3" >Coupon code</strong>
                                                <div className="form-group col pt-2 d-flex text-left">
                                                    <input
                                                        className="form-control form-control-sm"
                                                        id="couponCode"
                                                        name="couponCode"
                                                        type="text" 
                                                        placeholder={props.couponCode?props.couponCode:"Enter Coupon Code"}
                                                        value={couponCode}
                                                        onChange={(e)=>setCouponCode(e.target.value.toUpperCase())}
                                                        style={{ width: "100%",flex:"1",fontSize:"small" }}
                                                        disabled={props.disabled || props.cartLoading}
                                                        required
                                                    />
                                                     <button
                                                        type="button"
                                                        className="btn btn-outline-success btn-sm mb-2 mx-2 float-right"
                                                        style={{ display: `${props.displayApply}` }}
                                                        onClick={handleCouponApplyClick}
                                                        disabled={
                                                         props.couponAddBtnLoading || couponCode === ""
                                                        }
                                                    >
                                                        {props.couponAddBtnLoading ? "Verifying" : "Apply"}
                                                       
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-danger btn-sm mb-2 mx-2"
                                                        style={{ display: `${props.displayRemove}` }}
                                                        onClick={handleCouponRemoveClick}
                                                        disabled={props.couponRemoveBtnLoading}
                                                    >
                                                        {props.couponRemoveBtnLoading ? "Removing" : "Remove"}
                                                    </button>
                                                </div>            
                                            </div> 
                          {/* </div> */}
                             <div className={`col-xs-10  col-md-6 col-lg ${classes.CardMobile} p-3`}>
                                
                                    {!props.cartLoading&&( <div >
                                    <button className={`btn btn-secondary  ${classes.PlaceOrderBtn}`} 
                                        disabled={props.cartLoading}
                                        onClick={handlePlaceOrder}
                                        >Place your order
                                        
                                     </button>
                                     </div>)}
                                    {props.cartLoading&&( <div >
                                        <button className={`btn btn-secondary  ${classes.PlaceOrderBtn}`} 
                                        disabled={props.cartLoading}
                                        >Please Wait...</button>
                                     </div>)}
                                  
                                     <div className="text-left">
                                        <div className="pt-2">
                                        <strong >Order Summary</strong> 
                                        </div>
                                        
                                        {getOrderSummary()}
                                        <hr/>
                                            <div className="d-flex justify-content-between">
                                            
                                                <h6 className="text-danger">Order Total:</h6>
                                                <h6 className="text-danger">Rs {props.order.finalPrice}</h6>
                                            </div>
                                        <hr/>

                                     </div>
                                     
                                
                             </div>
                        {/* col-sm-6  col-lg */}
                   </div>
                   
                    <div className="row"> 
 
                        <div className="col-sm-12 col-lg-8">

                            {props.cartProducts.map(product=>(
                                <CartRow  
                                    key={Math.random()*1000}  
                                    product={product} 
                                    disabled={props.cartLoading}
                                    includeDeliveryComputation={true}
                                    
                                    /> 
                            ))}
                        </div> 
                      
                        {/* <div className="text-center" style={{position:"sticky",top:0}}>
                         <button className={`btn btn-secondary  ${classes.PlaceOrderBtn}`}>Place your order</button>
                     </div> */}
                    </div>

                </section>
            </div>
        </> 
    ); 
};

const mapStateToProps = state=>{
    return{
        order:state.cart.order,
        placeOrderBtnLoading:state.cart.placeOrderBtnLoading,
        cartProducts:state.cart.cartProducts,
        cartLoading:state.cart.loading,
        user: state.auth.user,
        orderSummary:state.cart.orderSummary,
    
        displayRemove: state.cart.displayRemove,
        displayApply: state.cart.displayApply,
        couponAddBtnLoading: state.cart.couponAddBtnLoading,
        couponRemoveBtnLoading: state.cart.couponRemoveBtnLoading,
        disabled:state.cart.disabled,
        response: state.cart.response,
        responseDisplay: state.cart.responseDisplay,
        couponCode:state.cart.couponCode
    }
}
const mapDispatchToProps = dispatch=>{
    return{
        onFetchCartProducts:(products,includeDelivery)=>dispatch(actions.fetchCartProducts(products,includeDelivery)),
        setOrderSummary:()=>dispatch(actions.setOrderSummary()),
        setCartOnProductsChange:(order)=>dispatch(actions.setCartOnProductsChange(order)),
        verifyCoupon:(couponCode,finalPrice,order)=>dispatch(actions.verifyCoupon(couponCode,finalPrice,order)),
        removeCoupon:(order,couponCode)=>dispatch(actions.removeCoupon(order,couponCode)),
        payOnline:(order)=>dispatch(actions.payOnline(order)),
        payCod: (order)=>dispatch(actions.payCod(order))
       
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(OrderReview)); 